import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaBook } from 'react-icons/fa';
import './DiaryEntry.css';
import '../components/WellnessButtons.css';

const DiaryEntry = ({ onSave }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [text, setText] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (text.trim()) {
      await onSave(text);
      setText('');
      setIsOpen(false);
    }
  };

  return (
    <>
      <div className="wellness-button" onClick={() => setIsOpen(true)}>
        <div className="wellness-button-header">
          <div className="wellness-button-title">
            <FaBook />
            <h3>Diary</h3>
          </div>
          <button className="wellness-button-expand">+</button>
        </div>
      </div>

      {isOpen && (
        <div className="diary-overlay" onClick={(e) => {
          if (e.target === e.currentTarget) setIsOpen(false);
        }}>
          <motion.div 
            className="diary-expanded-wrapper"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <form className="diary-form" onSubmit={handleSubmit}>
              <textarea
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Write your thoughts..."
                autoFocus
              />
              <div className="diary-actions">
                <button 
                  type="button" 
                  className="cancel-button"
                  onClick={() => setIsOpen(false)}
                >
                  Cancel
                </button>
                <button 
                  type="submit" 
                  className="save-button"
                  disabled={!text.trim()}
                >
                  Save Entry
                </button>
              </div>
            </form>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default DiaryEntry;